module.exports = __webpack_public_path__ + "static/media/snowboarding_768.971628e3.webp";